// src/pages/LoginPage.tsx

import { useState, useEffect } from "react";
import { login } from "../api/auth";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import "../styles/LoginPage.css";

export default function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [welcome, setWelcome] = useState("");
    const navigate = useNavigate();
    const { user, setUser } = useUser();

    // بررسی ورود خودکار
    useEffect(() => {
        const savedUser = localStorage.getItem("username");
        const savedDisplayName = localStorage.getItem("displayName");

        if (savedUser && savedUser.length > 3) {
            // بازگردانی کاربر به کانتکست
            setUser({ username: savedUser, displayName: savedDisplayName || savedUser });

            // هدایت به پروژه‌ها
            navigate("/projects");
        }
    }, [navigate, setUser]);

    // ارسال فرم ورود
    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        setError("");
        setWelcome("");

        try {
            const user = await login(username, password);

            // ذخیره در کانتکست و localStorage
            setUser({ username: user.username, displayName: user.displayName });
            localStorage.setItem("username", user.username);
            localStorage.setItem("displayName", user.displayName);

            // پیام خوش‌آمدی
            setWelcome(`خوش آمدی ${user.displayName}!`);

            // هدایت به پروژه‌ها
            setTimeout(() => navigate("/projects"), 500);
        } catch (err) {
            setError("نام کاربری یا گذرواژه اشتباه است");
        }
    }

    // خروج کاربر
    function handleLogout() {
        localStorage.removeItem("username");
        localStorage.removeItem("displayName");
        setUser(null);
        setUsername("");
        setPassword("");
        setWelcome("");
        navigate("/login");
    }

    return (
        <div className="login-container">
            <div className="login-box">
                <h2>ورود به سیستم</h2>

                {!user ? (
                    <form onSubmit={handleSubmit}>
                        <div>
                            <label>نام کاربری</label>
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>گذرواژه</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <p>
                            <button type="submit">ورود</button>
                        </p>
                    </form>
                ) : (
                    <div className="welcome-box">
                        <p>خوش آمدی {user.displayName || user.username} 🌟</p>
                        <button onClick={handleLogout}>خروج</button>
                    </div>
                )}

                {error && <p className="error">{error}</p>}
                {welcome && <p className="welcome">{welcome}</p>}
            </div>
        </div>
    );
}
